
import styled from "styled-components";
import {motion} from "framer-motion";

export default styled.div`


    overflow: hidden;

    position: relative;
    padding-top: 26px;
    ${props => props.theme.media.md} { 
       padding-top: 59px;
    }
   .slider-button-group {
     margin-top: 1rem;
     ${props => props.theme.media.md} { 
       margin-top: 1.5rem;
     }
     margin-bottom: 1.5rem;
     display: flex;
     justify-content: center;
     div {
       height: 14px;
       width: 14px;
       background: #CCCCCC;
       cursor: pointer;
       border-radius: 50%;
       &.active {
         background: #FE6712;
       }
       margin-right: 3px;
     }
   } 
   .slider-container {
      padding: 0 2rem;
      max-width: none;
      width: 100%;
      min-height: 690px;
      ${props => props.theme.media.xs} { 
        min-height: 560px;
      }
      ${props => props.theme.media.md} { 
         max-width: 675px;
         min-height: 411px;
         padding: 0
      }
      margin: auto;
      position: absolute;
      left: 50%;
      .imageWrapper {
        img {
          display: block;
          margin: auto;
          max-width: 144px;
        }
        margin-bottom: 0.5rem; 
      }
      
      .title {
        color: #FE6600;
        font-size: 26px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 0.5rem;
      }
      
      .quote {
        font-size: 28px;
        text-align: center;
        font-family: "Poppins";
        line-height: 1.5;
      }
      
      .attribution {
        font-size: 14px;
        text-align: center;
      }
      
      .stars {
        img {
          display: block;
          margin: auto;
          margin-top: 1rem;
        }
      }
   }
`;

